const officersData = {
  keyOfficials: [
    {
      id: 1,
      name: "Prof. Venkata Basava Rao",
      designation: "Hon'ble Vice-Chancellor"
    },
    // {
    //   id: 2,
    //   name: "Prof. N. T. K. Naik",
    //   designation: "Rector"
    // },
    {
      id: 3,
      name: "Prof. B. Vijaya Kumar Naidu",
      designation: "The Registrar"
    },
    
  ],

  principals: [
    {
      id: 1,
      name: "Prof. C. Viswanatha Reddy",
      designation: "The Principal, University College"
    },
    // {
    //   id: 2,
    //   name: "Prof. N. Narasimhulu",
    //   designation: "Vice-Principal, University College"
    // },
    {
      id: 3,
      name: "Prof. Venkata Sundaranand Putcha",
      designation: "The Principal, College of Engineering"
    }
  ],

  deans: [
    {
      id: 4,
      name: "Prof. C. V. Krishna Reddy",
      designation: "Dean, School of General Sciences "
    },
    
    {
      id: 5,
      name: "Prof. N. Narasimhulu",
      designation: "Dean, School of Arts and Management "
    },
    {
      id: 6,
      name: "Prof. Venkata Sundaranand Putcha",
      designation: "Dean, School of Engineering "
    },
    {
      id: 7,
      name: "Prof. Bharath Kumar Ravuru",
      designation: "Dean, School of Life Sciences "
    },
    {
      id: 1,
      name: "Prof. C. V. Krishna Reddy",
      designation: "Dean, Academic Affairs"
    },
    {
      id: 2,
      name: "Prof. N. Narasimhulu",
      designation: "Dean, Examinations"
    },
    {
      id: 3,
      name: "Prof. Venkata Sundaranand Putcha",
      designation: "Dean, College Development Council"
    },
    
  ],

  directors: [
    {
      id: 3,
      name: "Prof. N. T. K. Naik",
      designation: "Director, Directorate of Distance Education"
    },
    {
      id: 4,
      name: "Prof. N. T. K. Naik",
      designation: "Director, IQAC"
    },
    {
      id: 1,
      name: "Prof. N. Narasimhulu",
      designation: "Director, Directorate of Admissions"
    },
    {
      id: 2,
      name: "Prof. C. Viswanatha Reddy",
      designation: "Director, Research Studies"
    },
    {
      id: 4,
      name: "Dr. S. Venkateswarlu",
      designation: "Controller of Examinations"
    }
    
  ],

  wardensAndCoordinators: [
    {
      id: 1,
      name: "Prof. C. Viswanatha Reddy",
      designation: "Chief Warden, College Hostels"
    },
    {
      id: 2,
      name: "Prof. Venkata Sundaranand Putcha",
      designation: "Additional Chief Warden, College Hostels"
    },
    {
      id: 3,
      name: "Dr. B. Kavitha",
      designation: "NSS Coordinator"
    },
    {
      id: 4,
      name: "Dr. G. Surendhra",
      designation: "Placements Officer"
    },
    {
      id: 5,
      name: "A.Sreekanth",
      designation: "Placements Officer"
    },
    {
      id: 6,
      name: "Dr.M.Vijay Kumar",
      designation: "Website Co-ordinator"
    }
  ]
};

export default officersData;
